import React, { useContext } from 'react';
import { Col, Row } from 'reactstrap';
import Toggle from 'components/common/Toggle';
import { useTranslation } from 'react-i18next';
import DeleteButton from 'components/buttons/DeleteButton';
import ApiError from 'components/common/ApiError';
import CardWithLoader from 'components/common/CardWithLoader';
import APIResultMessage from 'components/common/APIResultMessage';
import InputList from 'components/common/InputList';
import { useList } from 'hooks/useList';
import { OBJ } from 'constants';
import { useContact } from 'hooks/useContact';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import { CONTACT_RELATIONSHIP_TYPE } from './ContactRelationshipDetails';

const ContactRelationshipManager = ({ openSection, setOpenSection, translationKey, type, onlyNew, contactId }) => {
    const { t } = useTranslation();
    const { userId } = useContext(UserSettingsContext);
    const { createContact, openContact } = useContact()
    const { list, toggleDelete, addLine, setAndSaveLineKey, isLoading, error, saveError, success, refetch } = useList(OBJ.CONTACT_RELATIONSHIPS, null, null, true, JSON.stringify({from_contact_id: contactId, type}));

    const contactRelationshipItems = [
        { label: 'contact_relationships.label.type', icon: 'link', key: 'type', type: 'iconSelect', options: CONTACT_RELATIONSHIP_TYPE, readOnly: true },
        { label: 'contact_relationships.label.to_contact_id', icon: 'person', key: 'to_contact_id', type: 'link', options: {type: OBJ.CUSTOMERS, filters: {contact_type: type}}, readOnly: true },
    ];
    
    const handleAddLine = async () => {
        let newContactId = null
        if(onlyNew){
            newContactId = await createContact({contact_type: type})
        }
        const newLine = { id: -1, type: type, from_contact_id: userId.contact_id, to_contact_id: newContactId }
        const newLines = await addLine(newLine)
        if(newContactId > 0){
            openContact(newContactId)
        }
    }
    
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message} />;
    return (
        <Toggle text={`${t(`${translationKey}.title`)} (${list?.items.length})`} section={`contact_relationships_${type}`} openSection={openSection} setOpenSection={setOpenSection}>
            <CardWithLoader
                isLoading={isLoading}
                footerButtonClick={handleAddLine}
                footerButtonText={t(`${translationKey}.new`)}
                lines={2}
                height={40}
            >
                <APIResultMessage success={success} error={saveError} />
                {list?.items.map((item) => (
                    <Row key={item.id} className="align-items-center">
                        <Col md="11">
                            <InputList fields={contactRelationshipItems} data={item} onChange={(key, value) => setAndSaveLineKey(item.id, key, value)} />
                        </Col>
                        <Col md="1">
                            <DeleteButton deleteItem={toggleDelete} id={item.id} />
                        </Col>
                    </Row>
                ))}
            </CardWithLoader>
        </Toggle>
    );
};

export default ContactRelationshipManager;
